/** Design FTO 首页首次引导的页面状态读取函数。 */
export interface DesignFtoOnboardingStartOptions {
    /** 获取当前页面是否为带任务 ID 的结果页。 */
    getHasTaskId: () => boolean;
    /** 获取首次历史记录请求是否仍在进行。 */
    getIsHistoryLoading: () => boolean;
    /** 获取 URL 图片是否已经成功上传并形成可提交的预填输入。 */
    getHasPrefilledInput: () => boolean;
    /** 获取当前 URL 是否要求自动运行任务。 */
    getIsAutoRunning: () => boolean;
}

/** Design FTO 上传、示例与提交操作引导 service。 */
export interface DesignFtoOnboardingService {
    /** 按当前页面、用户和展示状态尝试启动首次引导。 */
    start(options: DesignFtoOnboardingStartOptions): Promise<boolean>;
    /** 通知用户点击上传区或已经添加文件。 */
    notifyUploadSelected(): void;
    /** 通知用户选择了示例。 */
    notifyExampleSelected(): void;
    /** 通知图片上传完成且最终提交按钮已经可用。 */
    notifyUploadReady(): void;
    /** 通知用户聚焦预填说明输入框。 */
    notifyInputFocused(): void;
    /** 通知用户修改了预填说明文本。 */
    notifyManualInput(value: string): void;
    /** 消费一次由提交按钮引导产生的点击归因。 */
    consumeSubmitGuide(): boolean;
    /** 清理当前页面作用域内的全部引导资源。 */
    destroy(): void;
}

/** Design FTO 首页首次引导 service 的容器标识。 */
export const DesignFtoOnboardingService = Symbol('DesignFtoOnboardingService');
